import { render, staticRenderFns } from "./AccountChangePassword.vue?vue&type=template&id=366e90b9&"
import script from "./AccountChangePassword.vue?vue&type=script&lang=js&"
export * from "./AccountChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports